<div class="wallet-connect" [class.active]="!!wallet" (click)="connectWallet()">
	<a>
		<small class="block text-sm font-effra font-bold">{{ label }}</small>
		<mat-icon class="text-white">wallet</mat-icon>
	</a>
</div>
